"use strict";
/**
 *  @internal
 *  @module Utils
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkStatus = exports.parseJSON = void 0;
var tslib_1 = require("tslib");
var json_bigint_1 = require("@apimatic/json-bigint");
var APIError_js_1 = require("../errors/APIError.js");
var object_js_1 = require("./object.js");
var parseJSON = function (response, ignoreKeys) {
    if (ignoreKeys === void 0) { ignoreKeys = ["metadata"]; }
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var text;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, response.text()];
                case 1:
                    text = _a.sent();
                    return [2 /*return*/, text ? (0, object_js_1.transformKeys)((0, json_bigint_1.parse)(text), object_js_1.toCamelCase, ignoreKeys) : {}];
            }
        });
    });
};
exports.parseJSON = parseJSON;
var checkStatus = function (response) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var json;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (response.status >= 200 && response.status < 400) {
                    return [2 /*return*/, response];
                }
                return [4 /*yield*/, (0, exports.parseJSON)(response, ["metadata"])];
            case 1:
                json = _a.sent();
                throw new APIError_js_1.APIError(response.status, json);
        }
    });
}); };
exports.checkStatus = checkStatus;
//# sourceMappingURL=fetch.js.map